module.exports = __webpack_public_path__ + "img/strap_length.cfa264c6.png";